
import React, { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { Input } from '@/components/ui/input';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { useSlugGeneration } from '../hooks/useSlugGeneration';
import type { BlogPostFormData } from '@/services/blog/types';

interface TitleSlugFieldsProps {
  form: UseFormReturn<BlogPostFormData>;
}

export const TitleSlugFields: React.FC<TitleSlugFieldsProps> = ({ form }) => {
  const { control, watch, setValue } = form;
  const { generateSlugFromTitle } = useSlugGeneration();

  // Watch title field for slug generation
  useEffect(() => {
    const subscription = watch((value: Record<string, unknown>, { name }: { name?: string }) => {
      if (name === 'title' && value.title && typeof value.title === 'string') {
        generateSlugFromTitle(value.title).then((slug: string | null) => {
          if (slug) {
            setValue('slug', slug);
          }
        });
      }
    });

    return () => {
      if (subscription && typeof subscription.unsubscribe === 'function') {
        subscription.unsubscribe();
      }
    };
  }, [watch, setValue, generateSlugFromTitle]);

  return (
    <div className="space-y-4">
      <FormField
        control={control}
        name="title"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Title</FormLabel>
            <FormControl>
              <Input
                {...field}
                placeholder="Enter post title..."
                className="text-lg font-medium"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="slug"
        render={({ field }) => (
          <FormItem>
            <FormLabel>URL Slug</FormLabel>
            <FormControl>
              <Input
                {...field}
                placeholder="url-friendly-slug"
                className="font-mono text-sm"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
